import React,{Component} from 'react';

import './LiveMissions.css';

import { background_2, image2 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import Counters from '../../components/Counters/Counters';
import CumulativeStatistics from './content/CumulativeStatistics/CumulativeStatistics';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import request from '@acri-tools/react-tools/utils/request';

import { get_data_file_url, get_text_counter } from '../../utils/data';
import WeeklyStatistics from './content/WeeklyStatistics/WeeklyStatistics';
import { Helmet } from 'react-helmet';
import { get_page_title } from '../../utils/config';

interface Props{
}
interface State{
    loading: boolean,
    data? :any,

    loading_counters: boolean,
    counter_data? :any,
}



export default class LiveMissions extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            loading: false,
            loading_counters: false,
        }
    }

    componentDidMount(){
        this.fetch_data();
        this.fetch_counter_data();
    }

    fetch_counter_data = async () => {
        this.setState({ loading_counters: true });
        try {
            let res = await request(get_data_file_url(`live_stats.json`), { method: 'get' })

            this.setState({ counter_data: res.data });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch_counter_data` });
            toast_request_error(e);
        }
        finally {
            this.setState({ loading_counters: false })
        }
    }
    
    fetch_data = async () => {
        this.setState({ loading: true });
        try {
            let res = await request(get_data_file_url(`live_info_data_chart.json`), {
                method: 'get'
            })

            // console.debug("data", res.data);

            this.setState({ data: res.data });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch_data` });
            toast_request_error(e);
        }
        finally {
            this.setState({ loading: false })
        }
    }

    render(){
        let tabs = [
            // 0
            {
                label: <>Cumulative Statistics</>,
                content: <div className="live-missions-content">
                    <CumulativeStatistics data={this.state.data} loading={this.state.loading}/>
                </div>
            },
            // 1
            {
                label: <>Weekly Statistics</>,
                content: <div className="live-missions-content">
                    <WeeklyStatistics data={this.state.data} loading={this.state.loading}/>
                </div>
            },
        ]
        return (
        <Page 
            id="live-missions"
            banner={{
                title: "live missions",
                bannerImage: background_2,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title('DAMPS - Live Missions') }</title>
                <meta 
                    name="description" 
                    content="The DAMPS live missions page"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    <Counters
                        counters={[
                            get_text_counter("VOLUME OF ARCHIVED PRODUCTS", this.state.counter_data?.size, this.state.loading_counters),
                            get_text_counter("NUMBER OF ARCHIVED PRODUCTS", this.state.counter_data?.prod, this.state.loading_counters),
                        ]}
                    />
                </div>
                <div className="centered-content padding">
                    {/* <div className="">
                    </div> */}
                    <Tabs tabs={tabs}/>
                </div>
            </div>
        </Page>
        );
    }


};
